import React from 'react'

import Pagination, { IPaginationMenuItem } from '../../general/Pagination'
import { IPaging } from '@cbgms/api/response'
import { IPaginatedRequest } from '@cbgms/api'

export interface IKnockPaginationProps {
  loadData: (additionalParams?: IPaginatedRequest | undefined) => Promise<void>
  handlePageChange: (loadData: (additionalParams?: IPaginatedRequest | undefined) => Promise<void>, page: number) => Promise<void>
  handleLimitChange: (loadData: (additionalParams?: IPaginatedRequest | undefined) => Promise<void>, limit: number) => Promise<void>
  menuItems?: IPaginationMenuItem[]

  paging: IPaging
  heightOffset?: number
}

const withKnockPagination = (WrappedComponent: React.ComponentType<IKnockPaginationProps>) => (props: IKnockPaginationProps) => {
  const { paging, heightOffset, menuItems, loadData, handlePageChange, handleLimitChange } = props

  const onPageChange = async (page: number) => {
    await handlePageChange(loadData, page)
  }

  const onLimitChange = async (limit: number) => {
    await handleLimitChange(loadData, limit)
  }

  return (
    <React.Fragment>
      <WrappedComponent {...props} heightOffset={(heightOffset || 0) + 41} />

      <Pagination
        total={paging.Total}
        currentPage={paging.Page}
        totalPages={paging.TotalPages}
        limit={paging.PerPage}
        onPageChange={onPageChange}
        onLimitChange={onLimitChange}
        menuItems={menuItems}
        attached='bottom'
      />
    </React.Fragment>
  )
}

export default withKnockPagination
